import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { SelectAjaxSeeker, AsyncSelectSeeker } from 'ui-seeker/core'
import { REAL_TIME } from 'app/@common/constants'
import { getAppUserData } from 'app/@utils'


export default function SelectConnectivitiesStatic({...props}) {
    const { t } = useTranslation('common')
    const { role } = getAppUserData()

    const commonProps = {
        urlAjax: REAL_TIME.PACKAGES.ROUTES_LIST,
        icon: { icon: 'plane' },
        isMulti: false,
        isClearable: false,
        ...props
    }

    if (role === 'admin') {
        return <AsyncSelectSeeker {...commonProps} placeholder={t('filters.selectRoute')} extraParams={{ _sel: props.value }} />
    }

    return <SelectAjaxSeeker {...commonProps} placeholder={t('filters.allRoutes')} firstSelect={true} />
}
